export default "__VITE_ASSET__CniYvRpm__"